import { Button, ThemeTypings } from "@chakra-ui/react";
import React, { MouseEvent, ReactElement, ReactNode } from "react";

interface LinkButtonProps {
  onClick?: (evt: MouseEvent) => void;
  selected?: boolean;
  fontSize?: ThemeTypings["fontSizes"];
  children: ReactNode;
}

export default function LinkButton(props: LinkButtonProps): ReactElement {
  const { onClick, fontSize, selected, children } = props;

  return (
    <Button
      variant="link"
      size="sm"
      mx="1"
      minW={0}
      fontSize={fontSize}
      fontWeight={selected ? "bold" : undefined}
      color="teal.500"
      onClick={onClick}
    >
      {children}
    </Button>
  );
}
